export const VALID_EMAIL_PLEASE = "Introduza um email válido."
export const VALID_PASSWORD_PLEASE = "Introduza a password."
export const WRONG_CREDENTIALS = "Não foi possível iniciar sessão. Verifique credenciais."
